<template>
    <div>
        <div class="card-body">
            <div v-if="code_sent=='Y' && code_verified!='Y'">
                <div :class="code_incorrect=='N'?'alert alert-success':'alert alert-danger'">
                    {{ alertText }}
                </div>
                <div class="form-group row">
                    <label for="code" class="col-md-4 col-form-label text-md-right">Verification code:</label>

                    <div class="col-md-4">
                        <input id="verification_code" type="text" class="form-control" name="verification_code" required autocomplete="off" autofocus v-model="verification_code">
                    </div>
                    <div class="col-md-4 mt-3 offset-md-4">
                        <a href="" @click.prevent="checkVerificationCode" class="btn btn-primary btn-block">Submit Code</a>
                    </div>
                </div>
            </div>
            <div v-if="code_verified=='Y'">
                <div class="alert alert-success" role="alert">
                    Verification confirmed. Please continue registration process.
                </div>
            </div>
            <div v-if="code_verified=='N' && code_sent=='N'">Before proceeding, please verify your account.</div>
            <div class="row" v-if="code_verified=='N'">
                <div class="offset-md-2 col-md-4" v-if="use_phone === 'Y'">
                    <a href="" @click.prevent="sbVerify('sms')" class="btn btn-primary btn-block">{{
                            code_sent=='Y'?'Send New SMS':'SMS Verification'
                        }}</a>
                </div>
                <div class="col-md-4" v-if="use_email === 'Y'">
                    <a href="" @click.prevent="sbVerify('email')" class="btn btn-primary btn-block">{{
                            code_sent=='Y'?'Send New Email':'Email Verification'
                        }}</a>
                </div>
                <div v-if="use_phone === 'N' && use_email === 'N'" class="alert alert-danger">
                    This account can not be verified as there is no email or phone number on record.
                </div>
                <!--             <div class="col-md-4" v-if="use_code">-->
                <!--                 <a href="" @click.prevent="sbVerify('employer')" :class="code_sent=='Y'?'btn btn-primary btn-block disabled':'btn btn-primary btn-block'">Code given by the Employer</a>-->
                <!--             </div>-->
            </div>
            <div class="row" v-else>
                <div class="col-md-10 offset-md-1">
                    <a href="/register-profile" class="btn btn-primary btn-block">Continue Registration</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['phone','email','sent','verified'],
    mounted() {
        // if(this.code_sent=='Y' && this.code_verified=='N'){
        //     this.timer = setInterval(() => {
        //         this.checkDeviceValidation()
        //     }, 10000)
        // }
    },
    data(){
        return {
            route: '/api/user-verify',
            route_validation: '/api/check-validation',
            route_check_verification_code: 'api/check-verification-code',
            use_phone:this.phone,
            use_email:this.email,
            use_code:'Y',
            code_sent:this.sent,
            code_verified:this.verified,
            timer: null,
            verification_code: '',
            code_incorrect: 'N',
            teej: '',
            responseMessage: null
        }
    },
    computed: {
        alertText() {
            return this.code_incorrect === 'N'
                ? 'Verification code was sent. Awaiting verification.'
                : (this.responseMessage ?? 'Incorrect code. Please try again. Send a new code if needed.');
        }
    },
    methods:{
        log(s){
            console.log(s)
        },
        sbVerify(type){
            this.$http.post(this.route, {'type':type})
                .then(function(response) {
                    this.$notify({
                        type:'success',
                        title: 'Success',
                        text: 'Verification was sent!'
                    });
                    this.code_sent='Y';
                    // this.timer = setInterval(() => {
                    //     this.checkDeviceValidation()
                    // }, 10000)
                }, (response) => {
                    this._handleErrors(response.data, '#note-form')
                })
        },
        checkVerificationCode() {
            this.$http.post(this.route_check_verification_code, {verification_code: this.verification_code})
                .then(function(response) {
                    if (response.data.Status){
                        this.code_sent='Y';
                        this.code_verified='Y';
                        this.code_incorrect = 'N';
                        this.responseMessage = null;
                        clearInterval(this.timer)
                    } else {
                        this.code_incorrect = 'Y';
                        this.responseMessage = response.data.Message === "This user account is now locked and may not be accessed. Please try back later."
                            ? response.data.Message
                            : null;
                    }
                }, (response) => {
                    this._handleErrors(response.data, '#note-form')
                })
        },
        checkDeviceValidation:function (){
            this.$http.post(this.route_validation)
                .then(function(response) {
                    if (response.data.Status){
                        this.$notify({
                            type:'success',
                            title: 'Success',
                            text: 'Verification was sent!'
                        });
                        this.code_sent='Y';
                        this.code_verified='Y';
                        clearInterval(this.timer)
                    }
                }, (response) => {
                    this._handleErrors(response.data, '#note-form')
                })

        },
        _handleErrors: function(items, selector)
        {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="'+name+'"]')
                    el.closest('.form-group').addClass('has-error')
                    $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                }
            }
        }
    }

}
</script>
